import { Box, Typography } from '@mui/material'
import { products } from 'src/components/Products/enums'
import ProductsCard from 'src/components/Products/ProductsCard'

const Products = () => {
  return (
    <Box
      sx={{
        py: 5,
      }}
    >
      <Typography
        variant="h5"
        fontWeight="500"
        sx={{
          mb: 4,
          textAlign: 'center',
          borderBottom: `2px solid #000`,
          width: 'fit-content',
          mx: 'auto',
        }}
      >
        Our Products
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          justifyContent: 'space-evenly',
        }}
      >
        {products.map((device, index) => (
          <ProductsCard {...device} key={index} />
        ))}
      </Box>
    </Box>
  )
}

export default Products
